var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/quickshop-pagination.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n\n<div class=\"o-column o-extra-small--12 c-quickshop-pagination dom-quickshop-pagination\" data-qa-quickshop-pagination-controls>\n\n    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"disablePaging")) {
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"wrapPagination") || runtime.contextOrFrameLookup(context, frame, "hasPagePrev")) {
output += "\n\n            <a href=\"#\" class=\"c-quickshop-pagination__a c-quickshop-pagination__a--previous js-quickshop-pagination__a-previous\" aria-label=\"";
output += runtime.suppressValue((lineno = 9, colno = 144, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_previous"])), env.opts.autoescape);
output += "\">\n\n                &laquo; <span class=\"c-quickshop-pagination__text\">";
output += runtime.suppressValue((lineno = 11, colno = 69, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_previous"])), env.opts.autoescape);
output += "</span> &nbsp;\n\n            </a>\n\n        ";
;
}
else {
output += "\n\n            <span class=\"c-quickshop-pagination__a--previous c-quickshop-pagination__a--disabled\">\n\n                &laquo; <span class=\"c-quickshop-pagination__text is-disabled\"> ";
output += runtime.suppressValue((lineno = 19, colno = 82, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_previous"])), env.opts.autoescape);
output += "</span> &nbsp;\n\n            </span>\n\n        ";
;
}
output += "\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"wrapPagination") || runtime.contextOrFrameLookup(context, frame, "hasPageNext")) {
output += "\n\n            <a href=\"#\" class=\"c-quickshop-pagination__a c-quickshop-pagination__a--next js-quickshop-pagination__a-next\" aria-label=\"";
output += runtime.suppressValue((lineno = 27, colno = 136, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_next"])), env.opts.autoescape);
output += "\">\n\n                &nbsp; <span class=\"c-quickshop-pagination__text\">";
output += runtime.suppressValue((lineno = 29, colno = 68, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_next"])), env.opts.autoescape);
output += "</span> &raquo;\n\n            </a>\n\n        ";
;
}
else {
output += "\n\n            <span class=\"c-quickshop-pagination__a--disabled\">\n\n                &nbsp; <span class=\"c-quickshop-pagination__text is-disabled\">";
output += runtime.suppressValue((lineno = 37, colno = 80, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_next"])), env.opts.autoescape);
output += "</span> &raquo;\n\n            </span>\n\n        ";
;
}
output += "\n\n    ";
;
}
else {
output += "\n\n        &nbsp;\n\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/quickshop-pagination.j2"] , dependencies)